import { Entry } from './entry';

Entry.displayName = 'StackElement';

export { Entry as StackElement };
